import { render, staticRenderFns } from "./SecondaryHero.vue?vue&type=template&id=39c52b52&scoped=true&"
import script from "./SecondaryHero.vue?vue&type=script&lang=js&"
export * from "./SecondaryHero.vue?vue&type=script&lang=js&"
import style0 from "./SecondaryHero.vue?vue&type=style&index=0&id=39c52b52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c52b52",
  null
  
)

export default component.exports